import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
    commentContainer: {
        paddingTop: theme.spacing(2)
    },
    commentFlex: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1)
    },
    commentColOne: {
        flexGrow: 0,
        minWidth: 60
    },
    commentColTwo: {
        flexGrow: 1
    },
    commentColThree: {
        flexGrow: 0,
        minWidth: 60,
        textAlign: 'right'
    }
}));

export default function CommentSkeleton(props) {

    const classes = useStyles();

    return (
        <div className={classes.commentContainer}>
            <div className={classes.commentFlex}>
                <div className={classes.commentColOne}>
                    <Skeleton animation="wave" variant="circle" width={40} height={40} />
                </div>
                <div className={classes.commentColTwo}>
                    <Skeleton animation="wave" height={10} width="20%" />
                </div>
                <div className={classes.commentColThree}>

                </div>
            </div>
            <div className={classes.commentFlex}>
                <div className={classes.commentColOne}/>
                <div className={classes.commentColTwo}>
                    <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
                    <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
                    <Skeleton animation="wave" height={10} width="80%" />
                </div>
                <div className={classes.commentColThree}/>
            </div>
        </div>
    );
}
